import React, {memo, useMemo, useState} from 'react';
import {Col, Row, UiBox, UiImage, UiText} from '~/components/elements';
import {spacing} from '~/utils/theme/spacing';
import {AppCarousel} from '~/components/elements/AppCarousel';
import {BoxProps} from '@chakra-ui/react';
import {About} from '~/redux/questionnaires/types';

interface Props extends BoxProps {
  data?: About[];
}

export const MDQIntro = memo(function MDQIntro({data, ...rest}: Props) {
  return (
    <Col {...rest}>
      {data?.map(i => (
        <Row key={i?.icon} mb={spacing.smedium} display="flex" justifyContent="center" alignItems="center">
          <UiImage flex={2} type="icon" name={i?.icon} boxSize={spacing.large} mr={spacing.small} />
          <Col flex={4}>
            <UiText textAlign="left" fontSize="md" fontWeight="700" mb={spacing.mini}>
              {i?.title}
            </UiText>
            {i?.descriptions?.default?.map(description => (
              <UiText key={description} textAlign="left" color="blackSecondary" fontSize="xs">
                {description}
              </UiText>
            ))}
          </Col>
        </Row>
      ))}
    </Col>
  );
});
